import React from 'react';
import { Box, Paper, Alert } from '@mui/material';
import { DART_LOGO } from '../../config/constant';
import { useUserLogin } from '../../hooks/useUserLogin';
import { LoginForm } from './LoginForm';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { NewPasswordForm } from './NewPasswordForm';
import type { UserLoginProps } from './types';

export const UserLogin: React.FC<UserLoginProps> = ({ onLoginSuccess }) => {
  const {
    email, setEmail,
    password, setPassword,
    code, setCode,
    newPassword, setNewPassword,
    view,
    error,
    successMessage,
    loading,
    isChallengeReset,
    handleViewChange,
    handleLoginSubmit,
    handleForgotPasswordSubmit,
    handleNewPasswordSubmit,
  } = useUserLogin(onLoginSuccess);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f6fa' }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 400, borderRadius: 2 }}>

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3, mt: -1 }}>
          <img src={DART_LOGO} alt="DART Logo" style={{ maxWidth: '180px', width: '100%', height: 'auto', objectFit: 'contain' }} />
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}

        {/* 1. SIGN IN VIEW */}
        {view === 'login' && (
          <LoginForm
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            loading={loading}
            handleLoginSubmit={handleLoginSubmit}
            handleViewChange={handleViewChange}
          />
        )}

        {/* 2. FORGOT PASSWORD VIEW (REQUEST CODE) */}
        {view === 'forgot' && (
          <ForgotPasswordForm
            email={email}
            setEmail={setEmail}
            loading={loading}
            handleForgotPasswordSubmit={handleForgotPasswordSubmit}
            handleViewChange={handleViewChange}
          />
        )}

        {/* 3. CONFIRM RESET VIEW (SUBMIT NEW PASSWORD) */}
        {view === 'submit_new' && (
          <NewPasswordForm
            code={code}
            setCode={setCode}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            loading={loading}
            isChallengeReset={isChallengeReset}
            handleNewPasswordSubmit={handleNewPasswordSubmit}
            handleViewChange={handleViewChange}
          />
        )}
      </Paper>
    </Box>
  );
};

export default UserLogin;
